/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';
import { PartnerConnectionDto } from './partnerConnectionDto';
import { ImplementIdDto } from './implementIdDto';
import { MetaDataDto } from './metaDataDto';
import { GeoCoordinateDto } from './geoCoordinateDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface ExaAdapterStateV2Dto {
  activePartnerConnections?: Array<PartnerConnectionDto>;
  firmwareVersion?: string;
  id?: number;
  imsi?: string;
  jobstate?: string;
  lastHeartbeat?: string;
  mac?: string;
  metaData?: MetaDataDto;
  oem?: string;
  onlyGPS?: boolean;
  owner?: EnterpriseIdDto;
  pairedMachine?: MachineIdDto;
  position?: GeoCoordinateDto;
  primaryImplement?: ImplementIdDto;
  resource?: string;
  retailer?: EnterpriseIdDto;
  secondaryImplement?: ImplementIdDto;
  serial?: string;
  speed?: number;
  type?: string;
  updateTime?: string;
  workstate?: string;
}
